/* analytics event enums */

export const analyticsEventTypes = {
  CHAT_MESSAGE_RECEIVED: 'analytics/CHAT_MESSAGE_RECEIVED',
  CHAT_MESSAGE_SENT: 'analytics/CHAT_MESSAGE_SENT',
  CONTACT_US_CLICKED: 'analytics/CONTACT_US_CLICKED',
  ONBOARDING_SUBMITTED: 'analytics/ONBOARDING_SUBMITTED',
  QUICK_ACTION_SELECTED: 'analytics/QUICK_ACTION_SELECTED',
  SCREEN_SEARCH_RESULTS_VIEWED: 'analytics/SCREEN_SEARCH_RESULTS_VIEWED',
  SEARCH_RESULT_SELECTED: 'analytics/SEARCH_RESULT_SELECTED',
  SEARCHED: 'analytics/SEARCHED',
  WIDGET_LOADED: 'analytics/WIDGET_LOADED',
  WIDGET_OPENED: 'analytics/WIDGET_OPENED',
  WIDGET_CLOSED: 'analytics/WIDGET_CLOSED',
};

/* analytics event generators */

export const trackOnboardingSubmitted = ({ email, name }) => ({
  type: analyticsEventTypes.ONBOARDING_SUBMITTED,
  payload: { email, name },
});

export const trackClickContactUs = payload => ({
  type: analyticsEventTypes.CONTACT_US_CLICKED,
  payload,
});

export const trackChatMessageReceived = ({ message, messageId, subType }) => ({
  type: analyticsEventTypes.CHAT_MESSAGE_RECEIVED,
  payload: { messageId, messageLength: message.length, subType },
});

export const trackChatMessageSent = ({ message, messageId, isInitialMessage, type }) => ({
  type: analyticsEventTypes.CHAT_MESSAGE_SENT,
  payload: { messageId, messageLength: message.length, isInitialMessage, type },
});

export const trackQuickActionSelected = ({ entityId, entityType, label, position }) => ({
  type: analyticsEventTypes.QUICK_ACTION_SELECTED,
  payload: {
    entityId,
    entityType,
    label,
    position,
  },
});

export const trackScreenSearchResultsViewed = ({ searchId, searchResults, searchTerm }) => ({
  type: analyticsEventTypes.SCREEN_SEARCH_RESULTS_VIEWED,
  payload: {
    searchId,
    searchResults,
    searchTerm,
  },
});

export const trackSearchResultSelected = ({ entityId, entityType, label, position }) => ({
  type: analyticsEventTypes.SEARCH_RESULT_SELECTED,
  payload: {
    entityId,
    entityType,
    label,
    position,
  },
});

export const trackSearched = ({ searchId, searchTerm }) => ({
  type: analyticsEventTypes.SEARCHED,
  payload: { searchId, searchTerm },
});

export const trackWidgetOpened = ({ trigger }) => ({
  type: analyticsEventTypes.WIDGET_OPENED,
  payload: { trigger },
});

export const trackWidgetClosed = () => ({
  type: analyticsEventTypes.WIDGET_CLOSED,
});
